import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PrestacaoAluno } from "./prestacao-aluno";
import { InscricaoAluno } from "../inscricao-aluno/inscricao-aluno";
import { PrestacaoAlunoService } from "./prestacao-aluno.service";
import { InscricaoAlunoService } from "../inscricao-aluno/inscricao-aluno.service";
import { MatSnackBar } from "@angular/material";
import { RespostaListaDinamicaService } from "unb-questionario-componente";
import { Resposta } from "unb-questionario-componente";
import { SituacaoEnum } from "../util/situacao.enum";

@Component({
  selector: "prestacao-aluno-detail",
  templateUrl: "./prestacao-aluno-list.component.html",
  styleUrls: ["./prestacao-aluno-list.component.css"]
})
export class PrestacaoAlunoListComponent implements OnInit {
  public alunoPrestacao: PrestacaoAluno;
  public alunoRa: string;
  public resposta: Resposta;
  public sub: boolean = false;
  public isLoading: boolean;
  public botaoSalvar: boolean;
  public mostrarPainelValidacao: boolean = true;
  public mostrarPainelQuestionario: boolean;
  public mostrarPainelLista: boolean;
  public mensagemTela: string;
  public lista: InscricaoAluno[];
  public columnsToDisplay = [
    "id",
    "nome",
    "matricula",
    "periodo",
    "situacao",
    "acao"
  ];
  public pageSizeOptions = [10, 50, 100];

  @Input() botaoSalvarInput: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private prestacaoAlunoService: PrestacaoAlunoService,
    private respostaService: RespostaListaDinamicaService,
    private inscricaoAlunoService: InscricaoAlunoService,
    private mensagem: MatSnackBar
  ) {}

  ngOnInit() {
    let idInscricao: number = this.route.snapshot.params["inscricao"];
    this.sub = this.route.snapshot.params["sub"];
    if (idInscricao) {
      this.inscricaoAlunoService.getId(idInscricao).subscribe((result:InscricaoAluno) => {
         this.prestarConta(result);
        }, error => this.erro(error)
      );
    } else {
      this.carregaMatricula();
    }
  }

  carregaMatricula() {
    // carrega a matricula do  usuário pelo local storage
    let storage = JSON.parse(localStorage.getItem("editaldpg"));
    this.alunoRa = storage["user"];
    let filtro: InscricaoAluno = new InscricaoAluno();
    filtro.alunoRa = storage["user"];
    this.isLoading = true;
    this.inscricaoAlunoService.filtrar(filtro).subscribe(
      res => {
        if (res != null && res.length > 1) {
          this.lista = res;
          this.mostrarPainelLista = true;
          this.isLoading = false;
        } else if (res != null && res.length == 1) {
          let inscricao: InscricaoAluno = new InscricaoAluno();
          inscricao = res[0];
          if (
            inscricao.situacao == SituacaoEnum.Deferido.id ||
            inscricao.situacao == SituacaoEnum.PrestacaoContas.id ||
            inscricao.situacao == SituacaoEnum.PrestacaoNaoAprovada.id
          ) {
            this.prestarConta(res[0]);
          } else {
            this.mensagemTela =
              "Somente alunos com inscrições deferidas precisam prestar conta!";
          }
        } else {
          this.mensagemTela =
            "Somente alunos com inscrições deferidas precisam prestar conta!";
          this.isLoading = false;
        }
      },
      error => this.erro(error)
    );
  }

  public prestarConta(inscricao: InscricaoAluno) {
    if(inscricao.situacao == SituacaoEnum.Deferido.id ||
      inscricao.situacao == SituacaoEnum.PrestacaoContas.id ||
      inscricao.situacao == SituacaoEnum.PrestacaoNaoAprovada.id){
        this.alunoPrestacao = new PrestacaoAluno();
        this.alunoPrestacao.codigoInscricaoAluno = inscricao.id;
        this.isLoading = true;
        this.prestacaoAlunoService.filtrar(this.alunoPrestacao).subscribe(
          (results: PrestacaoAluno[]) => {
            if (results != null && results.length > 0) {
              this.alunoPrestacao = results[0];
              if (inscricao.situacao == SituacaoEnum.PrestacaoNaoAprovada.id) {
                this.mensagemTela = this.alunoPrestacao.motivoReprovacao;
              } else if (inscricao.situacao == SituacaoEnum.Finalizada.id){
                this.mostrarPainelValidacao = false;
              }
              this.carregaResposta(results[0].respostaQuestionario, inscricao);
            } else {
              this.resposta = null;
              this.mostrarPainelQuestionario = true;
              this.botaoSalvar = true;
              this.isLoading = false;
            }
          },
          error => this.erro(error)
        );
    }else {
      this.mensagemTela =
      "Somente inscrições deferidas precisam de prestação de conta!";
    }
  }

  private carregaResposta(idRespostaQuestionario: number, inscricao: InscricaoAluno) {
    this.respostaService
      .getRespostaCompletaPorPergunta(idRespostaQuestionario)
      .subscribe(
        (result: Resposta) => {
          if(inscricao.situacao == SituacaoEnum.PrestacaoContas.id){
            this.mensagemTela = "Prestação de contas já está salva no sistema.";
            if (this.sub) {
              this.botaoSalvar = true;
            }
          }else if (inscricao.situacao == SituacaoEnum.PrestacaoNaoAprovada.id){
            this.botaoSalvar = true;
          }else if(inscricao.situacao == SituacaoEnum.Finalizada.id){
            if(this.sub){
              this.botaoSalvar = true;
            }
            this.mensagemTela = "Processo Finalizado.";
          }

          this.mostrarPainelQuestionario = true;
          this.resposta = result;
          this.isLoading = false;
        },
        error => this.erro(error)
      );
  }

  salvarValidacao() {
    if (this.alunoPrestacao.status == 0 && !this.alunoPrestacao.motivoReprovacao) {
      this.mensagem.open(
        "Digite uma mensagem para não aprovação da prestação.",
        "X",
        { duration: 5000 }
      );
    } else {
      this.prestacaoAlunoService
        .validar(this.alunoPrestacao)
        .subscribe((result: PrestacaoAluno) => {
          this.alunoPrestacao = result;
          this.mensagem.open("Validação salva com sucesso!", "X", { duration: 5000 });
        }, error => this.erro(error));
    }
  }

  public respostaQuestionarioEmitida(event: number) {
    this.alunoPrestacao.respostaQuestionario = event;
    this.mensagemTela = null;
    this.prestacaoAlunoService.update(this.alunoPrestacao).subscribe(
      result => {
        this.alunoPrestacao = result;
        this.mensagemTela = "Prestação de contas salva com sucesso!";
        if (this.sub) {
          this.botaoSalvar = true;
        } else {
          this.botaoSalvar = false;
        }
        this.carregaMatricula();
        // this.carregaResposta(this.alunoPrestacao.respostaQuestionario, this.i);
      },
      error => {
        this.erro(error);
      }
    );
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
  }
}
